<button (click)="handleCancelar()" *ngIf="mostrar && !ocultarBotonSecundario">
  Cancelar
</button>
<button (click)="handleGuardar()" class="boton-guardar-cambios" *ngIf="mostrar">
  {{textoBotonPrincipal || "Guardar Cambios"}}
</button>
